import { DEGREE_PROCESSES } from '../../api/endpoints';
import request from '../../api/request';
import { DegreeProcessResponse } from './types';

export const getDegreeProcess = (studyPlanEnrollmentId: number) => {
  return request<DegreeProcessResponse>(
    DEGREE_PROCESSES.GET_DEGREE_PROCESS(studyPlanEnrollmentId),
    {
      method: 'GET',
    },
  );
};

export const updateDegreeDocument = ({
  studyPlanEnrollmentId,
  degreeDocumentId,
  ...data
}: {
  studyPlanEnrollmentId: number;
  degreeDocumentId: number;
  fileId: number | null;
}) => {
  return request<DegreeProcessResponse>(
    DEGREE_PROCESSES.UPDATE_DEGREE_DOCUMENT(
      studyPlanEnrollmentId,
      degreeDocumentId,
    ),
    {
      method: 'POST',
      data,
    },
  );
};
